<!-- Clicks stay in the panel, so the page behind it and the picker's own click-outside never see them. -->
<div class="color-panel" role="dialog" aria-label="Colour picker" cdkTrapFocus
     [class.color-panel--alpha]="alpha()" [class.color-panel--empty]="!color()" (click)="$event.stopPropagation()">
  <div class="color-panel__palette" (keydown)="paletteKey($event)">
    @for (row of palette(); track $index) {
    <div class="color-panel__palette-row">
      @for (swatch of row; track swatch.rgb) {
      <ng-container [ngTemplateOutlet]="swatchButton" [ngTemplateOutletContext]="{$implicit: swatch}"></ng-container>
      }
    </div>
    }
    <div class="color-panel__palette-row color-panel__palette-row--recent">
      @for (swatch of recentSwatches(); track swatch.rgb) {
      <ng-container [ngTemplateOutlet]="swatchButton" [ngTemplateOutletContext]="{$implicit: swatch}"></ng-container>
      }
    </div>
  </div>

  <div class="color-panel__picker">
    <div class="color-panel__top">
      <div class="color-panel__saturation" [style.background-color]="hueColor()" role="slider" tabindex="0"
           aria-label="Saturation and brightness" aria-valuemin="0" aria-valuemax="100"
           [attr.aria-valuenow]="color() ? saturationPercent() : null" [attr.aria-valuetext]="saturationText()"
           (keydown)="sliderKey($event, 'saturation')" (pointerdown)="dragStart($event, 'saturation')" (pointermove)="dragMove($event)"
           (pointerup)="dragEnd()" (lostpointercapture)="dragEnd()" (mousedown)="$event.preventDefault()">
        <div class="color-panel__saturation-white">
          <div class="color-panel__saturation-black">
            @if (color()) {
            <div class="color-panel__dragger"
                 [style.left]="'calc(' + state().hsva.s * 100 + '% - 10px)'"
                 [style.top]="'calc(' + (1 - state().hsva.v) * 100 + '% - 10px)'"></div>
            }
          </div>
        </div>
      </div>
      @if (allowEmpty()) {
      <button type="button" class="color-panel__clear" title="Clear Color Selection" aria-label="Clear Color Selection"
              (click)="clear()"></button>
      }
      <div class="color-panel__hue" [class.color-panel__hue--below-clear]="allowEmpty()" role="slider" tabindex="0"
           aria-label="Hue" aria-orientation="vertical" aria-valuemin="0" aria-valuemax="360"
           [attr.aria-valuenow]="color() ? hueDegrees() : null" [attr.aria-valuetext]="color() ? hueDegrees() + ' degrees' : 'No colour'"
           (keydown)="sliderKey($event, 'hue')" (pointerdown)="dragStart($event, 'hue')" (pointermove)="dragMove($event)"
           (pointerup)="dragEnd()" (lostpointercapture)="dragEnd()" (mousedown)="$event.preventDefault()">
        @if (color()) {
        <div class="color-panel__hue-handle" [style.top]="'calc(' + state().hsva.h * 100 + '% - 8px)'"></div>
        }
      </div>
      @if (alpha()) {
      <div class="color-panel__alpha" role="slider" tabindex="0" aria-label="Opacity" aria-valuemin="0" aria-valuemax="100"
           [attr.aria-valuenow]="color() ? alphaPercent() : null" [attr.aria-valuetext]="color() ? alphaPercent() + '%' : 'No colour'"
           (keydown)="sliderKey($event, 'alpha')" (pointerdown)="dragStart($event, 'alpha')" (pointermove)="dragMove($event)"
           (pointerup)="dragEnd()" (lostpointercapture)="dragEnd()" (mousedown)="$event.preventDefault()">
        <div class="color-panel__alpha-fill" [style.background]="alphaGradient()">
          @if (color()) {
          <div class="color-panel__alpha-handle" [style.left]="'calc(' + state().hsva.a * 100 + '% - 8px)'"></div>
          }
        </div>
      </div>
      }
    </div>

    <input #textField class="color-panel__input" type="text" spellcheck="false" aria-label="Colour"
           [class.color-panel__input--invalid]="invalidText()" [value]="text()"
           (change)="applyText(textField.value)" (keydown.enter)="applyText(textField.value)" (paste)="onTextPaste(textField)">

    <div class="color-panel__buttons">
      <button type="button" class="color-panel__cancel" (click)="cancelled.emit()">Cancel</button>
      <button type="button" class="color-panel__choose" (click)="choose()">Choose</button>
    </div>
  </div>
</div>

<ng-template #swatchButton let-swatch>
  <button type="button" class="color-panel__swatch" [class.color-panel__swatch--dark]="swatch.dark"
          [class.color-panel__swatch--active]="isActive(swatch)" [title]="swatch.title" [attr.aria-label]="swatch.title"
          [attr.aria-pressed]="isActive(swatch)" [tabindex]="swatch.rgb === paletteTabStop() ? 0 : -1" (click)="pick(swatch)">
    <span class="color-panel__swatch-fill" [style.background-color]="swatch.rgb"></span>
  </button>
</ng-template>
